export const EZEE_INTERNAL_ROLES = new Set([
  "administrator",
  "admin",
  "order-rep",
  "sales-rep",
  "operations-rep",
  "client-rep",
  "purchasing-rep",
  "production-rep",
  "shipping-rep",
  "finance-rep",
  "design-rep",
  "marketing-rep",
  "analytics-rep",
  "web-store-manager",
  "promostores-manager",
  "demo-user",
  "super-administrator",
  "finance",
  "production",
  "purchasing",
  "shipping",
  "manager",
  "management",
]);

export function normalizeEzeeRole(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "-");
}

export function canUseEzeeAI(authState = {}) {
  if (!authState?.status) return false;
  return EZEE_INTERNAL_ROLES.has(normalizeEzeeRole(authState.role));
}

export function isEzeeAdministrator(authState = {}) {
  const role = normalizeEzeeRole(authState.role);
  return role === "administrator" || role === "admin" || role === "super-administrator";
}
